import {
  AccountMovement,
  AccountMovementType,
  Debt,
  DebtType,
  PaymentStatus,
} from '../types';
import { translateDebtDescription } from './debtTranslation';
import { formatCurrency } from './currency';

export const isAccountMovement = (movement: Debt | AccountMovement): movement is AccountMovement => (
  'movementType' in movement
);

export const accountMovementDescription = (
  movement: Debt | AccountMovement,
  t: (key: string) => string,
): string => {
  if (!isAccountMovement(movement)) return translateDebtDescription(movement.description, t) || '—';

  switch (movement.movementType) {
    case AccountMovementType.SALE:
      if (movement.paymentStatus === PaymentStatus.PAID) {
        return `${t('debts.sale')} ${formatCurrency(movement.grossAmount ?? 0)} · ${t('debts.salePaidSummary')}`;
      }
      if (movement.paymentStatus === PaymentStatus.PARTIAL) {
        return `${t('debts.sale')} ${formatCurrency(movement.grossAmount ?? 0)} · ${t('debts.salePartialSummary')} · ${t('debts.remainingAmountShort')}: ${formatCurrency(movement.remainingAmount ?? 0)}`;
      }
      return `${t('debts.sale')} ${formatCurrency(movement.grossAmount ?? 0)} · ${t('debts.saleUnpaidSummary')}`;
    case AccountMovementType.CANCELLATION:
      return t('debts.saleCancellation');
    case AccountMovementType.MANUAL_PAYMENT:
      return movement.description || t('debts.manualPayment');
    case AccountMovementType.MANUAL_DEBT:
      return movement.description || t('debts.manualDebt');
    default:
      return movement.description || t('debts.movement');
  }
};

export const toEditableDebt = (movement: AccountMovement): Debt => ({
  id: movement.sourceDebtId || movement.id,
  customerId: movement.customerId,
  customerName: movement.customerName,
  description: movement.description,
  amount: movement.amount,
  transactionDate: movement.transactionDate,
  transactionDateTime: movement.transactionDateTime,
  debtType: movement.movementType === AccountMovementType.MANUAL_PAYMENT
    || movement.movementType === AccountMovementType.MANUAL_DEBT ? DebtType.MANUAL : DebtType.SALE,
  saleId: movement.saleId,
  saleNumber: movement.saleNumber,
  createdAt: '',
  updatedAt: '',
  createdByUsername: movement.createdByUsername || '',
});
